import type { OnActionType } from '../../../../context/ActionsProvider/context';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';

// web stub — live location tracking is native-only
function useTrackLiveLocation() {
  const onTrackLiveLocation: OnActionType = () => {
    console.warn('[LiveLocation] live location tracking is only available on mobile');
    return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
  };

  return { onTrackLiveLocation };
}

export default useTrackLiveLocation;
